module.exports = __webpack_public_path__ + "assets/reddit-ads.787259cb.svg";